var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 563.14 755.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3c99d3;stroke-linecap:round;stroke-linejoin:round;stroke-width:40px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": " \\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.9,249.65,504.84,695.72a58.75,58.75,0,0,1-58.56,54H160.56a58.73,58.73,0,0,1-58.55-54L66,249.82",
    transform: "translate(-21.86 -13.79)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 281.57,
    y1: 235.86,
    x2: 281.57,
    y2: 639.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.26,
    y1: 236.04,
    x2: 174.12,
    y2: 639.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 406.87,
    y1: 236.04,
    x2: 389,
    y2: 639.65
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "125.92 132.5 174.12 20 389 20 437.21 132.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 543.14,
    y1: 132.4,
    x2: 20,
    y2: 132.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.46ffd3c9.svg";
export { ForwardRef as ReactComponent };